module.exports = __webpack_public_path__ + "media/printed-materials/educators-04-college-calendar-8a0a1293.jpg";